import React from 'react';
import './Privacy.css';

const Privacy = () => {
  return (
    <main className="privacy-main">
      <div className="privacy-hero">
        <div className="privacy-hero-content">
          <h1>🛡️ Privacy Policy – Wonder Eventzz</h1>
          <p>Last updated: November 2025</p>
        </div>
      </div>

      <div className="privacy-content">
        <div className="privacy-section">
          <p className="intro-text">
            At Wonder Eventzz, accessible from wondereventzz.com, we are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you visit our website or contact us for balloon decoration or event services.
          </p>
        </div>

        <div className="privacy-section">
          <h2>1. Information We Collect</h2>
          <p>We may collect personal information such as:</p>
          <ul>
            <li>Name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Event details (date, location, theme, etc.)</li>
            <li>Payment information (processed securely via third-party gateways)</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use your data to:</p>
          <ul>
            <li>Provide and manage our balloon decoration and event services</li>
            <li>Respond to inquiries and provide quotations</li>
            <li>Send confirmations, updates, and promotional offers</li>
            <li>Improve our website and customer experience</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>3. Sharing of Information</h2>
          <p>We do not sell or trade your personal information. Your details may be shared only with:</p>
          <ul>
            <li>Service partners involved in fulfilling your booking</li>
            <li>Payment gateways or logistics providers (where applicable)</li>
            <li>Legal authorities, if required by law</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>4. Data Security</h2>
          <p>
            We use appropriate security measures to protect your personal data. However, no method of online transmission is 100% secure, and we cannot guarantee absolute security.
          </p>
        </div>

        <div className="privacy-section">
          <h2>5. Cookies</h2>
          <p>
            Our website may use cookies to improve user experience and analyze traffic. You can disable cookies in your browser settings if preferred.
          </p>
        </div>

        <div className="privacy-section">
          <h2>6. Your Rights</h2>
          <p>You may:</p>
          <ul>
            <li>Request access or correction of your personal data</li>
            <li>Opt out of promotional communications anytime</li>
            <li>Request data deletion by contacting us at support@wondereventzz.com</li>
          </ul>
        </div>

        <div className="privacy-section">
          <h2>7. Contact Us</h2>
          <p>If you have questions about this Privacy Policy, contact:</p>
          <div className="contact-info">
            <p>📩 Email: <a href="mailto:support@wondereventzz.com">support@wondereventzz.com</a></p>
            <p>📞 Phone: <a href="tel:+919001971755">9001971755</a></p>
            <p>🏢 Address: Shiv Mandir Sector 49, Noida, India</p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Privacy;

